import { VarBacktestApiResponse } from '../../queries';

export interface IOutSampleChartData {
  tick: string | number;
  dailypl: string | number;
  dailyvar: string | number;
  dailyplpercentage: string | number;
  dailyvarpercentage: string | number;
}

export function buildOutSampleBarChart(
  inputData: VarBacktestApiResponse[],
): IOutSampleChartData[] {
  const output = inputData[0].raptor_diff_data.map(
    (data: (string | number)[], index: number) => {
      return {
        dailypl: data[1],
        dailyvar: data[2],
        dailyplpercentage: data[4],
        dailyvarpercentage: data[5],
        //   tick: index % 30 === 0 ? data[0] : null,
        tick: data[0],
      };
    },
  );

  output.shift();

  return output;
}
